module.exports = __webpack_public_path__ + "static/media/Goomy_gaussian2.a8034ecb.png";